import React, { useState } from "react";
import moment from "moment";
import {Button, Radio, FormControlLabel, Grid} from "@material-ui/core";
import { Formik, Form } from "formik";
import DateSelector from "../../Shared/DateSelector";
import PropTypes from "prop-types";
import { changeToUSDate2 } from "../../../utils/date";

import FormModal from "../../FormModal";

const ModalSave = ({open, handleClose, handleSave, startDate, endDate}) => {

  const [dateSelected, setDateSelected] = useState(null);

  const _startDate = () => moment(changeToUSDate2(startDate));
  const _endDate = endDate ? moment(endDate).toDate() : null;
  
  const handleOnClose = () => {
    setDateSelected(null);
    handleClose();
  };

  const checkEndDate = () => {

     if (_endDate === null) {
      return false;
     }

     return true;
  }

  const checkEndDateInterval = () => {
     if (startDate !== moment(endDate).format('DD/MM/YYYY')) {
      return false;
     }

     return true;
  }

  const configRadio = () => {
    return [
      {label: `Somente para o dia ${startDate}`, value: startDate, datePicker: false, disabled: false},
      {label: `De ${startDate} à`, value: null, datePicker: true, disabled: checkEndDateInterval()},
      {label: `De ${startDate} em diante.`, value: "null", datePicker: false, disabled: checkEndDate()}
    ]
  }

  const hdlOnPeriodSelected = (setFieldValue, value) => {
    setFieldValue('endDatePicked', value);
  }

  return (
    <FormModal
      handleClose={handleOnClose}
      open={open}
      title={'Salvar'}
    >
      <Formik
        initialValues={
          {endDatePicked: -1}
        }
        onSubmit={(values) => {      
          const configStartDate =  _startDate().toDate();

          if (values.endDatePicked === 0) { 
            handleSave(configStartDate, configStartDate);
          } else  if (values.endDatePicked === 1) {
            handleSave(configStartDate, dateSelected);
          } else {
            handleSave(configStartDate, null);
          }
          handleOnClose();
        }}
      >
        {({values, setFieldValue}) => (
          <Form
            data-cy="plant-quota-form"
            id="plant-quota-form"
          >
            <Grid container spacing={3}>
            <Grid item xs={12}>
                <div
                  style={{
                    display: "flex",
                    height: "auto",
                    justifyContent: "flex-start",
                  }}
                >
                  <h3>Selecione o período de validade da configuração criada:</h3>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    {configRadio().map((item, index) => {
                      return (
                        (item.datePicker === false)
                        ? <FormControlLabel 
                          key= {index} 
                          value={index}
                          data-cy="period-select"
                          id="period-select"
                          checked={index === values.endDatePicked}
                          onChange={() => hdlOnPeriodSelected(setFieldValue, index)}
                          control={<Radio />} 
                          label={item.label}
                          disabled={item.disabled}
                        />
                        : <div
                            key={index}
                            style={{
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <FormControlLabel
                              value={index}
                              checked={index === values.endDatePicked}
                              data-cy="date-select"
                              id="date-select"
                              onChange={() => {
                                if (!dateSelected) {
                                  setDateSelected(_startDate().add(1, 'days').toDate());
                                }
                                hdlOnPeriodSelected(setFieldValue, index);
                              }}
                              control={<Radio />} 
                              label={item.label}
                              disabled={item.disabled}
                            />
                            <Grid
                              style= {{
                                width: "50%",
                                paddingRight: "0.5rem"
                              }}
                            >
                              <DateSelector
                                initialValue={_startDate().toDate()}
                                notClearable={true}
                                defineMinDateFromNow={1}
                                data-cy="end-data"
                                id="end-data"
                                defineMaxDateFromNow={_endDate}
                                disabled={item.disabled}
                                onChange={(event) => {
                                  
                                  if (moment(event).diff(moment(changeToUSDate2(startDate)), 'days') > 0) {
                                    setDateSelected(moment(event).toDate());
                                  } else {     
                                    setDateSelected(moment().add(1, 'days').toDate());
                                  }
                                  setFieldValue('endDatePicked', index);
                                }}
                                selected={dateSelected}
                              />
                            </Grid>
                          </div>
                      )
                    })}
                    
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div>
                  <p><strong>Atenção</strong></p>
                  <ul>
                    <li>As configurações serão salvas considerando os limites de data do turno.</li>
                    <li>Outras configurações dentro do intervalo selecionado serão substituídas.</li>
                    <li>Configurações fora deste intervalo não serão afetadas.</li>
                  </ul>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div
                  style={{
                    display: "flex",
                    height: 56,
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    data-cy="plant-quota-cancel"
                    id="plant-quota-cancel"
                    onClick={ () => {
                      handleOnClose();
                    }}
                    style={{ minWidth: "100%" }}
                    size="large"
                  >
                    Cancelar
                  </Button>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div
                  style={{
                    display: "flex",
                    height: 56,
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    data-cy="plant-quota-save"
                    id="plant-quota-save"
                    disabled={values.endDatePicked === -1}
                    style={{ minWidth: "100%" }}
                    size="large"
                    type="submit"
                  >
                    Salvar
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </FormModal>
  )
}

ModalSave.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired
};

export default ModalSave;
